import { css } from 'styled-components';
export const navDropdownShadow = css `
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
`;
export const screenReaderOnly = css `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
export const focusOutline = css `
  outline: none;
  outline-color: ${o => o.theme.color.effect.focus.outline.on.background};
  outline-offset: ${o => o.focusOutlineOffset ? `${o.focusOutlineOffset}px` : `calc(${o.theme.spacing(1)} / 2)`};
  outline-width: calc(${o => o.theme.spacing(1)} / 2);
  &:focus-visible {
    outline-style: solid;
  }
`;
export const focusOutlineInset = css `
  ${focusOutline};
  outline-offset: ${o => o.focusOutlineOffset ? `-${o.focusOutlineOffset}px` : `-${o.theme.spacing(1)}`};
`;
//# sourceMappingURL=index.js.map